/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalMCPTaskStatus } from './InternalMCPTaskStatus';
import {
    InternalMCPTaskStatusFromJSON,
    InternalMCPTaskStatusFromJSONTyped,
    InternalMCPTaskStatusToJSON,
    InternalMCPTaskStatusToJSONTyped,
} from './InternalMCPTaskStatus';

/**
 * 
 * @export
 * @interface InternalMCPTaskUpdateRequest
 */
export interface InternalMCPTaskUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof InternalMCPTaskUpdateRequest
     */
    ownerUserId: string;
    /**
     * 
     * @type {string}
     * @memberof InternalMCPTaskUpdateRequest
     */
    ownerClientId: string;
    /**
     * 
     * @type {number}
     * @memberof InternalMCPTaskUpdateRequest
     */
    expectedVersion?: number;
    /**
     * 
     * @type {InternalMCPTaskStatus}
     * @memberof InternalMCPTaskUpdateRequest
     */
    status?: InternalMCPTaskStatus;
    /**
     * 
     * @type {string}
     * @memberof InternalMCPTaskUpdateRequest
     */
    statusMessage?: string | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof InternalMCPTaskUpdateRequest
     */
    inputResponses?: { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof InternalMCPTaskUpdateRequest
     */
    resultSchemaVersion?: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof InternalMCPTaskUpdateRequest
     */
    result?: { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof InternalMCPTaskUpdateRequest
     */
    errorSchemaVersion?: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof InternalMCPTaskUpdateRequest
     */
    error?: { [key: string]: any; };
}



/**
 * Check if a given object implements the InternalMCPTaskUpdateRequest interface.
 */
export function instanceOfInternalMCPTaskUpdateRequest(value: object): value is InternalMCPTaskUpdateRequest {
    if (!('ownerUserId' in value) || value['ownerUserId'] === undefined) return false;
    if (!('ownerClientId' in value) || value['ownerClientId'] === undefined) return false;
    return true;
}

export function InternalMCPTaskUpdateRequestFromJSON(json: any): InternalMCPTaskUpdateRequest {
    return InternalMCPTaskUpdateRequestFromJSONTyped(json, false);
}

export function InternalMCPTaskUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalMCPTaskUpdateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'ownerUserId': json['owner_user_id'],
        'ownerClientId': json['owner_client_id'],
        'expectedVersion': json['expected_version'] == null ? undefined : json['expected_version'],
        'status': json['status'] == null ? undefined : InternalMCPTaskStatusFromJSON(json['status']),
        'statusMessage': json['status_message'] == null ? undefined : json['status_message'],
        'inputResponses': json['input_responses'] == null ? undefined : json['input_responses'],
        'resultSchemaVersion': json['result_schema_version'] == null ? undefined : json['result_schema_version'],
        'result': json['result'] == null ? undefined : json['result'],
        'errorSchemaVersion': json['error_schema_version'] == null ? undefined : json['error_schema_version'],
        'error': json['error'] == null ? undefined : json['error'],
    };
}

export function InternalMCPTaskUpdateRequestToJSON(json: any): InternalMCPTaskUpdateRequest {
    return InternalMCPTaskUpdateRequestToJSONTyped(json, false);
}

export function InternalMCPTaskUpdateRequestToJSONTyped(value?: InternalMCPTaskUpdateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'owner_user_id': value['ownerUserId'],
        'owner_client_id': value['ownerClientId'],
        'expected_version': value['expectedVersion'],
        'status': InternalMCPTaskStatusToJSON(value['status']),
        'status_message': value['statusMessage'],
        'input_responses': value['inputResponses'],
        'result_schema_version': value['resultSchemaVersion'],
        'result': value['result'],
        'error_schema_version': value['errorSchemaVersion'],
        'error': value['error'],
    };
}

